var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list',[_vm._l((_vm.buildings),function(building){return [_c('building-list-tile',{key:building.id,attrs:{"building":building}}),_c('v-divider',{key:'divider-' + building.id})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }